import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment as ENV } from "environments/environment";
const API = "trabajos/";
@Injectable({
    providedIn: "root",
})
export class TrabajoService {
    constructor(private http: HttpClient) {}

    informarPago(idTrabajo: number, monto: number) {
        const requestOptions: Object = {
            responseType: "blob",
        };

        return this.http.put<string>(
            `${ENV.apiUrl}${API}${idTrabajo}/pagar?monto=${monto}`,
            null,
            requestOptions
        );
    }

    fetchImagenAvanceTrabajo(idFoto: number) {
        return this.http.get(`${ENV.apiUrl}${API}avance/${idFoto}`, {
            responseType: "blob",
        });
    }
}
